/* eslint-disable max-len */
import { DownOutlined, AppstoreAddOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type LocalCustomerManagementModuleSpecsFragment } from '../../../../api/fragments/LocalCustomerManagementModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useAddKYCPresetDrawer } from './AddKYCPresetDrawer';

export type LocalCustomerModuleActionsProps = {
    module: LocalCustomerManagementModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const LocalCustomerModuleActions = ({ module, permissions }: LocalCustomerModuleActionsProps) => {
    const { t } = useTranslation(['localCustomerModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const addKYCPresetsDrawer = useAddKYCPresetDrawer(module.id);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('localCustomerModuleDetails:mainActionButtons.addKYCPresets'),
            key: 'addKYCPresets',
            icon: <AppstoreAddOutlined />,
            onClick: addKYCPresetsDrawer.open,
        },
        hasDeletePermission && {
            label: t('localCustomerModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('localCustomerModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {addKYCPresetsDrawer.render()}
        </>
    );
};

export default LocalCustomerModuleActions;
